import React from 'react';
import Banner from "./home/Banner"
// import ServicesOne from './home/ServicesOne';
import SlidingText from './home/SlidingText';
// import EventOne from './home/EventOne';
import About from './home/About';
import TeamOne from './home/TeamOne';
import EventDirection from './home/EventDirection';
import GalleryOne from './home/GalleryOne';
// import ScheduleOne from './home/ScheduleOne';
// import BrandOne from './home/BrandOne';
import BlogOne from './home/BlogOne';
import CTAOne from './home/CTAOne';
import YouTubeGallery from "./home/components/YoutubeVids"

const HomeMain = () => {
    return (
        <main className="main-wrapper"> {/* Wrap in a main tag for SEO */}
            <Banner />
            <SlidingText />
            
            <section className="content-section-gap">
                <About />
            </section>

            <TeamOne />
            <EventDirection />
            
            {/* Grouping related media content */}
            <div className="media-showcase-wrapper" style={{ background: '#070410' }}>
                <GalleryOne />
                <YouTubeGallery />
            </div>

            <BlogOne />
            
            {/* CTA should usually be the very last thing before the footer */}
            <CTAOne />
        </main>
    );
}

export default HomeMain;